import * as React from 'react'

import { Icon, IconProps } from './Icon'

export const PhotoIcon: React.FC<IconProps> = props => (
  <Icon fill="currentColor" {...props}>
    <path
      d="M3.5875 20.4125C3.97917 20.8042 4.45 21 5 21H19C19.55 21 20.0208 20.8042 20.4125 20.4125C20.8042 20.0208 21 19.55 21 19V5C21 4.45 20.8042 3.97917 20.4125 3.5875C20.0208 3.19583 19.55 3 19 3H5C4.45 3 3.97917 3.19583 3.5875 3.5875C3.19583 3.97917 3 4.45 3 5V19C3 19.55 3.19583 20.0208 3.5875 20.4125ZM19 19H5V5H19V19ZM18 17H6L9 13L11.25 16L14.25 12L18 17ZM9.19922 10.55C10.0276 10.55 10.6992 9.87843 10.6992 9.05C10.6992 8.22158 10.0276 7.55 9.19922 7.55C8.37079 7.55 7.69922 8.22158 7.69922 9.05C7.69922 9.87843 8.37079 10.55 9.19922 10.55Z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </Icon>
)
